import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { forwardRef, useRef, useContext, memo } from 'react';
import { HoverItemContext } from './constants.js';
import { jsx } from 'react/jsx-runtime';
const withHovering = (name, WrappedComponent) => {
  const Component = /*#__PURE__*/memo(WrappedComponent);
  const WithHovering = /*#__PURE__*/forwardRef((props, ref) => {
    const itemRef = useRef(null);
    return /*#__PURE__*/jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
      itemRef: itemRef,
      externalRef: ref,
      isHovering: useContext(HoverItemContext) === itemRef.current
    }));
  });
  WithHovering.displayName = "WithHovering(".concat(name, ")");
  return WithHovering;
};
export { withHovering };